<template>
  <div class="add-client-form row-height bottom-buttons-div no-padding">
    <div class="col-md-12">
      <successModal
        ref="success_modal"
        v-on:confirm="closeSuccessModal"
      ></successModal>
      <h3>
        <span class="font"> Settings</span>
      </h3>
      <v-form ref="form" v-model.trim="valid" class="col-md-12">
        <v-row class="mt-3">
          <div class="col-lg-12 col-xl-5 col-md-12 align-center no-padding">
            <h4 class="settings-text text-underline">Employer Access</h4>
            <div class="d-flex">
              <v-checkbox v-model.trim="sendMail"></v-checkbox>
              <span class="settings-text text-gray mt-5"
                >Send an email that enables us to approve or deny every employer
                relationship:</span
              >
            </div>
          </div>
          <div class="col-lg-12 col-xl-7 col-md-12 col-md-12 no-padding">
            <label class="text-gray font ml-3" for=""
              >Enter email(s) where notifications should be sent:</label
            >
            <v-row justify="space-around">
              <v-col cols="12">
                <v-text-field
                  class="ml-3"
                  style="width: 50%; float: left"
                  v-model.trim="email1"
                  :rules="email1 ? emailRules : []"
                  solo
                >
                  <template v-slot:append>
                    <v-btn icon @click="pushToTags('1')"
                      ><v-icon>mdi-plus</v-icon></v-btn
                    >
                  </template>
                </v-text-field>

                <v-chip-group
                  mandatory
                  class="primary--text"
                  :class="tags.length > 4 ? 'col-md-11 mb-10 no-padding' : ''"
                >
                  <v-chip
                    v-for="(tag, index) in tags"
                    :key="index"
                    class="primary--text v-chip--active ml-1"
                  >
                    {{ tag }}
                    <i
                      class="fa fa-times fa-2xs ml-1"
                      @click="removeFromTags(index, '1')"
                    ></i>
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
          </div>
        </v-row>
        <v-row class="">
          <div class="col-lg-12 col-xl-5 col-md-12 align-center no-padding">
            <h4 class="settings-text text-underline">Visit Passes</h4>
            <div class="d-flex">
              <v-checkbox v-model.trim="sendMail1"></v-checkbox>
              <span class="settings-text text-gray mt-5"
                >Send all Visit Pass related notifications to the emails listed
                here:</span
              >
            </div>
          </div>
          <div class="col-lg-12 col-xl-7 col-md-12 col-md-12 no-padding">
            <label class="text-gray font ml-3" for=""
              >Enter email(s) where notifications should be sent:</label
            >
            <v-row justify="space-around">
              <v-col cols="12">
                <v-text-field
                  class="ml-3"
                  style="width: 50%; float: left"
                  v-model.trim="email2"
                  :rules="email2 ? emailRules : []"
                  solo
                >
                  <template v-slot:append>
                    <v-btn icon @click="pushToTags('2')"
                      ><v-icon>mdi-plus</v-icon></v-btn
                    >
                  </template>
                </v-text-field>

                <v-chip-group
                  mandatory
                  class="primary--text"
                  style="height: 43px"
                >
                  <v-chip
                    v-for="(tag, index) in tags2"
                    :key="tag"
                    class="primary--text v-chip--active ml-2"
                  >
                    {{ tag }}
                    <i
                      class="fa fa-times fa-2xs ml-1"
                      @click="removeFromTags(index, '2')"
                    ></i>
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
          </div>
        </v-row>
        <!-- 
           <div class="row ">
             <h4 class="text-gray font text-gray text-underline">Rate Visibility</h4>
           </div>
           <v-row>
            <div class="d-flex  col-md-6 align-center no-padding">
              <v-checkbox v-model.trim="participate"></v-checkbox> <span class="font text-gray">We do not want to participate as a <a>Preferred Provider.</a></span>
            </div>
           </v-row>-->
      </v-form>
      <v-snackbar v-model.trim="snackbar" :timeout="1000" color="red">
        {{ snackbarText }}

        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>

    <div class="row col-md-12 justify-end" align="end">
      <v-btn class="blue-buttons">Update & Save</v-btn>
    </div>
  </div>
</template>
<script>
import api from "../../../../../services/api";
import successModal from "../../../../TablesTemplate/SuccessDialog.vue";
export default {
  components: {
    successModal,
  },
  data() {
    return {
      sendMail: false,
      sendMail1: "",
      participate: false,
      hideRates: false,
      clickToShow: false,
      requestToShow: false,
      sendNotification: false,
      emails: [],
      tags: [],
      tags2: [],
      tags3: [],
      snackbar: false,
      snackbarText: "",
      myDeleteArray: [],
      myAddArray: [],
      email: "",
      email1: "",
      email2: "",
      email3: "",
      email4: "",
      newEmail: "",
      valid: false,
      valid1: false,
      domainRules: [
        (v) => !!v || "This field is required",
        (v) =>
          /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/.test(v) ||
          "Email domain is not valid!",
      ],
      emailRules: [
        (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "E-mail must be valid",
      ],
    };
  },
  created() {
    // this.getSettings();
  },
  methods: {
    pushToTags(row) {
      if (row == "1") {
        if (
          this.email1 != null &&
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email1)
        ) {
          let index = this.tags.findIndex((c) => c == this.email1);
          if (index == -1) {
            this.tags.push(this.email1);
            this.email1 = "";
          } else {
            this.snackbarText = "Email already exists";
            this.snackbar = true;
          }
        } else {
          this.snackbarText = "Email is not valid";
          this.snackbar = true;
        }
      } else if (row == "2") {
        if (
          this.email2 != null &&
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email2)
        ) {
          let index = this.tags2.findIndex((c) => c == this.email2);
          if (index == -1) {
            this.tags2.push(this.email2);
            this.email2 = "";
          } else {
            this.snackbarText = "Email already exists";
            this.snackbar = true;
          }
        } else {
          this.snackbarText = "Email is not valid";
          this.snackbar = true;
        }
      } else {
        if (
          this.email3 != null &&
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email3)
        ) {
          let index = this.tags3.findIndex((c) => c == this.email3);
          if (index == -1) {
            this.tags3.push(this.email3);
            this.email3 = "";
          } else {
            this.snackbarText = "Email already exists";
            this.snackbar = true;
          }
        } else {
          this.snackbarText = "Email is not valid";
          this.snackbar = true;
        }
      }
    },
    removeFromTags(index, row) {
      if (row == "1") {
        this.tags.splice(index, 1);
      } else if (row == "2") {
        this.tags2.splice(index, 1);
      } else {
        this.tags3.splice(index, 1);
      }
    },

    fillDomainRules() {
      this.domainRules = [
        (v) => !!v || "This field is required",
        (v) =>
          /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/.test(v) ||
          "Email domain is not valid!",
      ];
    },
    pushToArray() {
      this.$refs.form1.validate();

      let data = {
        domain: this.newEmail,
      };
      if (this.valid1) {
        api()
          .post("/auth/validateEmail", data)
          .catch((err) => {
            if (err) {
              this.domainRules = ["Only company email domains are allowed"];
            }
          })
          .then((res) => {
            if (res) {
              api()
                .get("/auth/isValidDomain?domain=" + this.newEmail)
                .catch((err) => {
                  if (err) {
                    this.domainRules = [err.response.data.message];
                    exist = true;
                  }
                })
                .then((res) => {
                  let regex =
                    /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/;
                  let check = regex.test(this.newEmail);
                  if (this.newEmail && this.valid1 && check) {
                    this.emails.push({ domain: this.newEmail });
                    this.myAddArray.push({ domain: this.newEmail });
                    this.$refs.success_modal.openPopUp(
                      "Domain added successfully"
                    );
                    this.$refs.form.resetValidation();
                    this.newEmail = "";
                  }
                });
            }
          });
      }
    },
    removeFromArray(email) {
      this.myDeleteArray.push(email);
      for (let i = 0; i < this.emails.length; i++) {
        if (this.emails[i] == email) {
          this.emails.splice(i, 1);
        }
      }
      this.$refs.success_modal.openPopUp("Domain was successfully deleted!");
    },
    showOrHideRates(text) {
      if (text == "hide") {
        this.hideRates = true;
        this.requestToShow = false;
      } else {
        this.hideRates = false;
        this.requestToShow = true;
      }
    },
    closeSuccessModal() {
      this.$refs.success_modal.closePopUp();
    },
  },
};
</script>

<style>
.settings-text {
  font-family: "Quicksand", sans-serif;
  font-weight: 600;
  color: #9fa2b4 !important;
}

.bottom-buttons-div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>